"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var react_addons_css_transition_group_1 = __importDefault(require("react-addons-css-transition-group"));
var ActiveUsers = (0, mobx_react_1.observer)(function (_a) {
    var users = _a.users;
    return (react_1.default.createElement("div", { className: "active-users" },
        react_1.default.createElement(react_addons_css_transition_group_1.default, { component: react_1.default.Fragment, transitionName: "active-users__scale", transitionEnterTimeout: 200, transitionLeaveTimeout: 200 }, users.map(function (user) {
            var firstName = user.firstName, lastName = user.lastName;
            return (react_1.default.createElement("div", { key: "active-user-".concat(user.id), className: "active-user" },
                react_1.default.createElement(kaleidoscope_1.Tooltip, { wrapTarget: true, content: "".concat(firstName, " ").concat(lastName), position: kaleidoscope_1.TooltipPosition.Bottom },
                    react_1.default.createElement(kaleidoscope_2.Avatar, { firstName: firstName, lastName: lastName }))));
        }))));
});
exports.default = ActiveUsers;
